export default {
  'LoginPage.signIn': 'Sign In',
  'LoginPage.noAccount': 'No account?',
  'LoginPage.register': 'Register Now',
  'LoginPage.signInSecondary': 'SIGN IN',
  'LoginPage.email': 'E-mail',
  'LoginPage.password': 'Password',
  'LoginPage.forgot': 'Forgot your password?',

  'Validation.error.required': 'This field is required',
  'Validation.error.invalidEmail': 'Please enter a valid email address',
  'Validation.error.invalidTitle': 'Invalid title format.',

  'RegisterPage.registered': 'Already registered?',
  'RegisterPage.login': 'Login now',
  'RegisterPage.email': 'Email',
  'RegisterPage.password': 'Password',
  'RegisterPage.repeatPassword': 'Repeat Password',
  'RegisterPage.register': 'CREATE AN ACCOUNT',

  'ForgotPage.title': 'Forgot password?',
  'ForgotPage.desc1': 'Enter your',
  'ForgotPage.desc2': 'email',
  'ForgotPage.next': 'NEXT',
  'ForgotPage.return': 'Return to sign in',
  'ForgotPasswordPage.email': 'email',
  'ForgotPage.error': 'An error occurred. Please try again.',

  'Main.settings': 'Settings',
  'Main.logout': 'Logout',

  'NoteEditPage.cancel': 'Cancel',
  'NoteEditPage.save': 'Save',
  'NoteEditPage.title': 'Title',
  'NoteEditPage.text': 'Enter note text here',

  'NotePage.editNote': 'Edit note',
  'NotePage.copyNote': 'Copy note',
  'NotePage.goBack': 'Go back',

  'NotesPage.selectAll': 'Select all',
  'NotesPage.deleteNote': 'Delete note',
  'NotesPage.sortBy': 'Sort by',
  'NotesPage.date': 'Date',
  'NotesPage.title': 'Title',
  'NotesPage.text': 'Text',
  'NotesPage.addNote': 'Add new note',
  'NotesPage.uploadFile': 'Upload File',
  'NotesPage.templateManager': 'Template Manager',
  'NotesPage.noNotes.title': 'No notes yet',
  'NotesPage.noNotes.desc1':
    "Oh no! Seems like you didn't create any notes yet.",
  'NotesPage.noNotes.desc2': 'Start by pressing the button.',

  'Search.placeholder': 'Search',

  'TemplatesPage.noTemplates.title': 'No Templates Found',
  'TemplatesPage.noTemplates.desc1': "You haven't created any templates yet.",
  'TemplatesPage.noTemplates.desc2':
    'Click the button below to add a new template.',
  'TemplatesPage.addTemplate': 'Create Template',

  'AudioFilePage.noAudioFile.title': 'No Audio File Found',
  'AudioFilePage.noAudioFile.desc1': "You haven't uploaded any audio file yet.",
  'AudioFilePage.noAudioFile.desc2': "You haven't uploaded any audio file yet.",

  'Settings.currentPassword': 'Current password',
  'Settings.newPassword': 'New password',
  'Settings.repeatPassword': 'Repeat password',
  'Settings.changePassword': 'Change password',
  'Settings.language': 'Language',
  'Settings.vocabulary': 'Vocabulary',

  'UploadFile.note': 'Title',
  'TemplateManager.fieldId': 'Field Id',

  'OtpVerifyPage.title': 'Verify OTP',
  'OtpVerifyPage.desc':
    'Enter the OTP sent to your email to verify your identity.',
  'OtpVerifyPage.error': 'An error occurred. Please try again.',
  'OtpVerifyPage.otp': 'OTP Code',
  'OtpVerifyPage.submit': 'Verify OTP',
  'OtpVerifyPage.resend': 'Resend OTP',

  'ResetPasswordPage.title': 'Reset Password',
  'ResetPasswordPage.desc': 'Enter your new password to reset your account.',
  'ResetPasswordPage.error': 'An error occurred. Please try again.',
  'ResetPasswordPage.newPassword': 'New Password',
  'ResetPasswordPage.confirmPassword': 'Confirm Password',
  'ResetPasswordPage.submit': 'Reset Password',
  'ResetPasswordPage.login': 'Return to Login',
};
